module.exports = __webpack_public_path__ + "static/media/call_with_emery_nolasco.8fabae77.jpg";